import { Link } from 'react-router-dom';
import { categories } from '@/mocks/games';

interface ArticleCardProps {
  id: number;
  title: string;
  category: string;
  image: string;
  excerpt: string;
  date: string;
  slug: string;
  author: string;
}

export default function ArticleCard({
  title,
  category,
  image,
  excerpt,
  date,
  slug,
  author,
}: ArticleCardProps) {
  const categoryInfo = categories.find((c) => c.slug === category);

  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative aspect-[2/1] overflow-hidden">
        <img
          src={image}
          alt={title}
          title={`${title} - 黄游免费下载`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="p-5">
        {categoryInfo && (
          <span className="inline-block px-2.5 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
            {categoryInfo.name}
          </span>
        )}
        <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-user-line text-xs"></i>
            {author}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line text-xs"></i>
            {date}
          </span>
        </div>
      </div>
    </Link>
  );
}